import { push } from 'connected-react-router'
import React from 'react'
import { useDispatch } from 'react-redux'
import Button from '../../utils/Button'
import Facilities from './Facilities'

import RequestFormStep1Facility from './step1Facility.js'

const RequestFormStep1 = () => {
  const dispatch = useDispatch()

  return (
    <div className="mb-24">
      <RequestFormStep1Facility />
      <Facilities />

      <div className="mt-6 md:flex md:space-x-4">
        <Button color="green" onClick={() => dispatch(push('/explore'))} className="mt-6">
          Explore the over 5,000 parks and campgrounds we support.
        </Button>

        <Button color="green" onClick={() => dispatch(push('/added'))} className="mt-6">
          Recently Added and Updated
        </Button>
      </div>
    </div>
  )
}

export default RequestFormStep1
